import {
    BrandBuildingsIcon,
    BrandTenementIcon,
    FloorGroundIcon,
    FloorLowerIcon,
    FloorTopIcon,
    FloorUpperIcon,
    FloorWithoutGroundIcon,
    FloorWithoutTopIcon
} from "@pg-design/icons-module";

import {ConstructionEndDateType} from "../../types/ConstructionEndDateType";
import {
    HomeMatchFinancingPreference,
    HomeMatchFloorsPreference,
    HomeMatchPreferencesMarketType,
    HomeMatchPreferencesSurveyBuildingHeight,
    HomeMatchPreferencesSurveyPropertyType
} from "./home_match_preferences_values";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "./home_match_preferences_wizard_content";

export const HOME_MATCH_PREFERENCES_SURVEY_CONTENT = {
    ADDITIONAL_EXPECTATIONS: "Udogodnienia",
    BUDGET_QUESTION: "Maksymalna cena",
    BUILDING_HEIGHT: "Wysokość zabudowy",
    CLOSE: "Zamknij",
    COMPLETION_DATE: "Termin oddania inwestycji",
    DESCRIPTION: "Uzupełnij kryteria, a pokażemy Ci dopasowane oferty. Możesz je później zmienić.",
    DISCARD: "ANULUJ ZMIANY",
    EXIT_DESCRIPTION: "Twoje odpowiedzi z ankiety nie zostały zapisane. Jeśli teraz wyjdziesz, przepadną i trzeba będzie zacząć od nowa.",
    EXIT_LEAVE: "WYJDŹ BEZ ZAPISYWANIA",
    EXIT_RETURN: "WRÓĆ DO ANKIETY",
    EXIT_RETURN_SUMMARY: "WRÓĆ DO PODSUMOWANIA",
    EXIT_TITLE: "Wyjść bez zapisywania?",
    FINANCING: "Jak planujesz sfinansować zakup?",
    FLOOR: "Piętro",
    LOCATION_QUESTION: "Gdzie szukasz nieruchomości?",
    MARKET_BOTH: "Rynek pierwotny + wtórny",
    ROOMS: "Liczba pokoi",
    AREA: "Powierzchnia",
    AREA_FROM: "Metraż od",
    AREA_MAX_WARNING: "Maksymalna wartość:",
    AREA_MIN_WARNING: "Minimalna wartość:",
    AREA_RANGE_SEPARATOR: "-",
    AREA_TO: "Metraż do",
    AREA_UNIT: "m2",
    SAVE: "ZAPISZ KRYTERIA",
    SAVE_ERROR: "Wystąpił błąd podczas zapisywania preferencji",
    SAVE_SUCCESS: "Zmiany preferencji zostały zapisane",
    SECONDARY_MARKET: "Poszukuję też na rynku wtórnym",
    TITLE: "Czego szukasz"
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_SECTIONS = {
    ADDITIONAL: "Termin i udogodnienia",
    BUDGET: "Budżet",
    FEATURES: "Budynek i piętro",
    LOCATION: "Lokalizacja",
    PROPERTY_TYPE: "Typ nieruchomości",
    SIZE: "Wielkość nieruchomości"
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES = [
    {label: "Mieszkania", value: HomeMatchPreferencesSurveyPropertyType.FLAT},
    {label: "Domy", value: HomeMatchPreferencesSurveyPropertyType.HOUSE}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_MARKETS = [
    {label: "Rynek pierwotny", value: HomeMatchPreferencesMarketType.PRIMARY},
    {label: "Rynek wtórny", value: HomeMatchPreferencesMarketType.SECONDARY}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_FLOORS = [
    {label: "Parter", value: HomeMatchFloorsPreference.GROUND},
    {label: "Bez parteru", value: HomeMatchFloorsPreference.WITHOUT_GROUND},
    {label: "Piętra 1-4", value: HomeMatchFloorsPreference.LOW},
    {label: "Piętra 5 i wyższe", value: HomeMatchFloorsPreference.HIGH},
    {label: "Ostatnie piętro", value: HomeMatchFloorsPreference.TOP},
    {label: "Bez ostatniego", value: HomeMatchFloorsPreference.WITHOUT_TOP}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS = [
    {label: "Wysokie budynki", value: HomeMatchPreferencesSurveyBuildingHeight.HIGH},
    {label: "Niskie budynki", value: HomeMatchPreferencesSurveyBuildingHeight.LOW}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES = [
    {label: "Gotowe do odbioru", value: ConstructionEndDateType.READY},
    {label: "Do 3 miesięcy", value: ConstructionEndDateType.THREE_MONTHS},
    {label: "Do 6 miesięcy", value: ConstructionEndDateType.SIX_MONTHS},
    {label: "Do roku", value: ConstructionEndDateType.YEAR},
    {label: "Do 2 lat", value: ConstructionEndDateType.TWO_YEARS},
    {label: "Do 3 lat", value: ConstructionEndDateType.THREE_YEARS}
] as const;

const {FINANCING: FINANCING_LABELS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

// The survey API accepts an area bound from 20 to 500 m2.
export const HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX = 500;
export const HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN = 20;

export const HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS = [
    {label: FINANCING_LABELS.CREDIT, value: HomeMatchFinancingPreference.CREDIT},
    {label: FINANCING_LABELS.CASH, value: HomeMatchFinancingPreference.CASH},
    {label: FINANCING_LABELS.UNKNOWN, value: HomeMatchFinancingPreference.UNKNOWN}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS = {
    [HomeMatchFloorsPreference.GROUND]: FloorGroundIcon,
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: FloorWithoutGroundIcon,
    [HomeMatchFloorsPreference.LOW]: FloorLowerIcon,
    [HomeMatchFloorsPreference.HIGH]: FloorUpperIcon,
    [HomeMatchFloorsPreference.TOP]: FloorTopIcon,
    [HomeMatchFloorsPreference.WITHOUT_TOP]: FloorWithoutTopIcon
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS = {
    [HomeMatchPreferencesSurveyPropertyType.FLAT]: BrandBuildingsIcon,
    [HomeMatchPreferencesSurveyPropertyType.HOUSE]: BrandTenementIcon
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS = [
    {label: "Ogródek", value: 4},
    {label: "Garaż", value: 5},
    {label: "Komórka lokatorska", value: 6},
    {label: "Piwnica", value: 7},
    {label: "Miejsce postojowe", value: 8},
    {label: "Miejsce postojowe wewnętrzne", value: 9},
    {label: "Miejsce postojowe zewnętrzne", value: 10},
    {label: "Box", value: 11}
] as const;
import {
    BrandBuildingsIcon,
    BrandTenementIcon,
    FloorGroundIcon,
    FloorLowerIcon,
    FloorTopIcon,
    FloorUpperIcon,
    FloorWithoutGroundIcon,
    FloorWithoutTopIcon
} from "@pg-design/icons-module";

import {ConstructionEndDateType} from "../../types/ConstructionEndDateType";
import {
    HomeMatchFinancingPreference,
    HomeMatchFloorsPreference,
    HomeMatchPreferencesMarketType,
    HomeMatchPreferencesSurveyBuildingHeight,
    HomeMatchPreferencesSurveyPropertyType
} from "./home_match_preferences_values";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "./home_match_preferences_wizard_content";

export const HOME_MATCH_PREFERENCES_SURVEY_CONTENT = {
    ADDITIONAL_EXPECTATIONS: "Udogodnienia",
    BUDGET_QUESTION: "Maksymalna cena",
    BUILDING_HEIGHT: "Wysokość zabudowy",
    CLOSE: "Zamknij",
    COMPLETION_DATE: "Termin oddania inwestycji",
    DESCRIPTION: "Uzupełnij kryteria, a pokażemy Ci dopasowane oferty. Możesz je później zmienić.",
    DISCARD: "ANULUJ ZMIANY",
    EXIT_DESCRIPTION: "Twoje odpowiedzi z ankiety nie zostały zapisane. Jeśli teraz wyjdziesz, przepadną i trzeba będzie zacząć od nowa.",
    EXIT_LEAVE: "WYJDŹ BEZ ZAPISYWANIA",
    EXIT_RETURN: "WRÓĆ DO ANKIETY",
    EXIT_RETURN_SUMMARY: "WRÓĆ DO PODSUMOWANIA",
    EXIT_TITLE: "Wyjść bez zapisywania?",
    FINANCING: "Jak planujesz sfinansować zakup?",
    FLOOR: "Piętro",
    LOCATION_QUESTION: "Gdzie szukasz nieruchomości?",
    MARKET_BOTH: "Rynek pierwotny + wtórny",
    ROOMS: "Liczba pokoi",
    AREA: "Powierzchnia",
    AREA_FROM: "Metraż od",
    AREA_MAX_WARNING: "Maksymalna wartość:",
    AREA_MIN_WARNING: "Minimalna wartość:",
    AREA_RANGE_SEPARATOR: "-",
    AREA_TO: "Metraż do",
    AREA_UNIT: "m2",
    SAVE: "ZAPISZ KRYTERIA",
    SAVE_ERROR: "Wystąpił błąd podczas zapisywania preferencji",
    SAVE_SUCCESS: "Zmiany preferencji zostały zapisane",
    SECONDARY_MARKET: "Poszukuję też na rynku wtórnym",
    TITLE: "Czego szukasz"
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_SECTIONS = {
    ADDITIONAL: "Termin i udogodnienia",
    BUDGET: "Budżet",
    FEATURES: "Budynek i piętro",
    LOCATION: "Lokalizacja",
    PROPERTY_TYPE: "Typ nieruchomości",
    SIZE: "Wielkość nieruchomości"
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES = [
    {label: "Mieszkania", value: HomeMatchPreferencesSurveyPropertyType.FLAT},
    {label: "Domy", value: HomeMatchPreferencesSurveyPropertyType.HOUSE}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_MARKETS = [
    {label: "Rynek pierwotny", value: HomeMatchPreferencesMarketType.PRIMARY},
    {label: "Rynek wtórny", value: HomeMatchPreferencesMarketType.SECONDARY}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_FLOORS = [
    {label: "Parter", value: HomeMatchFloorsPreference.GROUND},
    {label: "Bez parteru", value: HomeMatchFloorsPreference.WITHOUT_GROUND},
    {label: "Piętra 1-4", value: HomeMatchFloorsPreference.LOW},
    {label: "Piętra 5 i wyższe", value: HomeMatchFloorsPreference.HIGH},
    {label: "Ostatnie piętro", value: HomeMatchFloorsPreference.TOP},
    {label: "Bez ostatniego", value: HomeMatchFloorsPreference.WITHOUT_TOP}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS = [
    {label: "Wysokie budynki", value: HomeMatchPreferencesSurveyBuildingHeight.HIGH},
    {label: "Niskie budynki", value: HomeMatchPreferencesSurveyBuildingHeight.LOW}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_COMPLETION_DATES = [
    {label: "Gotowe do odbioru", value: ConstructionEndDateType.READY},
    {label: "Do 3 miesięcy", value: ConstructionEndDateType.THREE_MONTHS},
    {label: "Do 6 miesięcy", value: ConstructionEndDateType.SIX_MONTHS},
    {label: "Do roku", value: ConstructionEndDateType.YEAR},
    {label: "Do 2 lat", value: ConstructionEndDateType.TWO_YEARS},
    {label: "Do 3 lat", value: ConstructionEndDateType.THREE_YEARS}
] as const;

const {FINANCING: FINANCING_LABELS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

// The survey API accepts an area bound from 20 to 500 m2.
export const HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX = 500;
export const HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN = 20;

export const HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS = [
    {label: FINANCING_LABELS.CREDIT, value: HomeMatchFinancingPreference.CREDIT},
    {label: FINANCING_LABELS.CASH, value: HomeMatchFinancingPreference.CASH},
    {label: FINANCING_LABELS.UNKNOWN, value: HomeMatchFinancingPreference.UNKNOWN}
] as const;

export const HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS = {
    [HomeMatchFloorsPreference.GROUND]: FloorGroundIcon,
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: FloorWithoutGroundIcon,
    [HomeMatchFloorsPreference.LOW]: FloorLowerIcon,
    [HomeMatchFloorsPreference.HIGH]: FloorUpperIcon,
    [HomeMatchFloorsPreference.TOP]: FloorTopIcon,
    [HomeMatchFloorsPreference.WITHOUT_TOP]: FloorWithoutTopIcon
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS = {
    [HomeMatchPreferencesSurveyPropertyType.FLAT]: BrandBuildingsIcon,
    [HomeMatchPreferencesSurveyPropertyType.HOUSE]: BrandTenementIcon
} as const;

export const HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS = [
    {label: "Ogródek", value: 4},
    {label: "Garaż", value: 5},
    {label: "Komórka lokatorska", value: 6},
    {label: "Piwnica", value: 7},
    {label: "Miejsce postojowe", value: 8},
    {label: "Miejsce postojowe wewnętrzne", value: 9},
    {label: "Miejsce postojowe zewnętrzne", value: 10},
    {label: "Box", value: 11}
] as const;
